import { handleActions } from "redux-actions";
import produce from "immer";
import set from "lodash/set";
import { updateWorkflow } from "../actions/workflowActions";

const initialState = {};

export const workflowReducer = handleActions(
  {
    [updateWorkflow]: produce((draftState, { payload }) => {
      set(draftState, payload?.channel, payload?.workflow);
    })
  },
  initialState
);
